import axios from '../assets/axios'
// MOBILE :修改手机 
// CONTACTS :修改联系人
// CHANGE_APPLY_INFO("信息变更申请书"),
// ID_CARD_FRONT("身份证正面"),
// ID_CARD_BACK("身份证背面"),
// REAL_NAME_SCREEN("新手机号运营商实名认证截图"),
// HOLDING_ID_CARD_PHOTO("手持身份证露肘照片"),
// PAYMENT_CARD_PHOTO("收款卡照片"),
// LOAN_HISTORY_SCREEN(我司平台放款流水"),

export default {
  namespaced: true,
  state: {},
  mutations: {},
  actions: {

    async saveChange ({ commit }, params) {
      const response = await axios.post('/user-change/v1/saveChange', params)
      return response.data
    },
    async userChangeConfirm ({ commit }, params) {
      const response = await axios.post('/user-change/v1/confirm', params)
      return response.data
    },
    async userChangeReason ({ commit }, params) {
      const response = await axios.post('/user-change/v1/reason', params)
      return response.data
    },
    async getChangeConfig ({ commit }, params) {
      const response = await axios.post('/user-change/v1/getChangeConfig', params)
      return response.data
    },
    async commit ({ commit }, params) {
      const response = await axios.post('/user-change/v1/commit', params)
      return response.data
    },
    async uploadImage ({ commit }, params) {
      const response = await axios.post('/user-change/v1/uploadImage', params)
      return response.data
    },
    async fillContent ({ commit }, params) {
      const response = await axios.post('/user-change/v1/fillContent', params)
      return response.data
    }
  }
}
